(() => {
  function init(root = document) {
    root.querySelectorAll('[data-lavista-reviews]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('.lavista-reviews__track');
      const prev = section.querySelector('[data-review-prev]');
      const next = section.querySelector('[data-review-next]');
      const progress = section.querySelector('.lavista-reviews__progress');
      const indicator = progress.firstElementChild;
      const dialog = section.querySelector('dialog');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let frame = 0;
      const update = () => {
        frame = 0;
        const max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft < 2;
        next.disabled = max < 2 || track.scrollLeft >= max - 2;
        const fraction = max > 0 ? Math.max(0, Math.min(1, track.scrollLeft / max)) : 0;
        indicator.style.setProperty('--lr-progress', `${fraction * (progress.clientWidth - indicator.clientWidth)}px`);
      };
      const move = direction => {
        const cards = track.children;
        if (!cards.length) return;
        const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
        track.scrollBy({left: direction * step, behavior: reduced.matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') track.scrollTo({left:event.key === 'Home' ? 0 : track.scrollWidth, behavior:reduced.matches ? 'instant' : 'smooth'});
        else move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, {passive:true});
      const observer = new ResizeObserver(update);
      observer.observe(track);
      section.addEventListener('click', event => {
        const button = event.target.closest('[data-review-photo]');
        if (!button) return;
        const source = button.querySelector('img');
        const image = dialog.querySelector('img');
        image.src = source.currentSrc || source.src;
        image.alt = source.alt;
        dialog.showModal();
      });
      dialog.querySelector('[data-review-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(section)) return;
        observer.disconnect();
        if (frame) cancelAnimationFrame(frame);
      });
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
